import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";

import { main_url } from "../../../utils/CommonFunction";
import { getApi, getHeaders } from "../../../utils/apiHelper";

import SettingHeader from "../SettingHeader";
import SalaryTemplateAddNew from "./salary_template_add_new/SalaryTemplateAddNew";
import SalaryTemplateTable from "./salary_template_table/SalaryTemplateTable";

export default class SalaryTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddNew: false,
      isTable: true,
      datasource: [],
      editData: {},
      level_options: [],
      sub_level_options: [],
    };
  }

  async componentDidMount() {
    const datasource = await this.getSalaryTemplate();
    const level = await this.getLevelOptions();
    const sub_level = await this.getCareerSubLevelOptions();
    const level_options = level.map((v) => ({
      ...v,
      label: v.career_level,
      value: v.career_level,
    }));
    const sub_level_options = sub_level.map((v) => ({
      ...v,
      label: v.career_sub_level,
      value: v.career_sub_level,
    }));
    this.setState({
      datasource,
      level_options,
      sub_level_options,
    });
  }

  getSalaryTemplate = async () => {
    const data = await getApi(`${main_url}salaryTemplate/getSalaryTemplate`);
    if (data) return data;
    else return [];
  };

  getLevelOptions = async () => {
    var res = await fetch(`${main_url}allowLevel/getLevel`, {
      headers: getHeaders(),
    });
    if (res.ok) return res.json();
    else return [];
  };

  getCareerSubLevelOptions = async () => {
    var res = await fetch(`${main_url}allowLevel/getCareerSubLevel`, {
      headers: getHeaders(),
    });
    if (res.ok) return res.json();
    else return [];
  };

  setupForm = () => {
    this.setState({
      isAddNew: true,
      isTable: false,
    });
  };

  goToTable = () => {
    this.setState({
      isAddNew: false,
      isTable: true,
    });
    window.location.reload();
  };

  showToast = (status, text) => {
    if (status === 200) {
      toast.success(text);
      window.location.reload();
    } else {
      toast.error(text);
    }
  };

  render() {
    const { level_options, sub_level_options } = this.state;
    return (
      <div className="salary-template border-bottom white-bg dashboard-header">
        <ToastContainer position={toast.POSITION.TOP_RIGHT} />
        <SettingHeader
          pageTitle="Salary Template"
          setupForm={this.setupForm}
          isAddNew={this.state.isAddNew}
          permission={{ isAddNew: true }}
        />
        {this.state.isTable ? (
          <SalaryTemplateTable
            data={this.state.datasource}
            level_options={level_options}
            sub_level_options={sub_level_options}
            goToEditForm={this.goToEditForm}
            goToViewForm={this.goToViewForm}
          />
        ) : (
          ""
        )}
        {this.state.isAddNew ? (
          <SalaryTemplateAddNew
            goToTable={this.goToTable}
            data={this.state.datasource}
            showToast={this.showToast}
            level_options={level_options}
            sub_level_options={sub_level_options}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
